import styled from 'styled-components';

export const UiEditQuestionnairePage = styled.div`
	display: block;
`;